import axios from 'axios';



export default {
    runScript: function(script, parameters) {
        var postData = {
            fieldData : {
				postData: parameters
            },
            script : script,
            'script.param' : parameters
        }
        return axios.post(`runScript.php`, postData)
            .then((response)=>{
                return response.data
            })
            .catch((e)=>{
                if(e.response.data.messages[0].message){
                    //Return FM Error Response
                    return e.response.data
                }else{
                    //Format Unknown Error Like a FM Error
                    return  `{ messages:[message: ${e.message}, code: -1],response: {}}`;
                }
            })
    },
    downloadDocument: function(documentID){
        return axios.post(`downloadDocument.php`, documentID)
        .then((response) => {
            // success callback
            return response.data
        })
        .catch( (e) => {
            if(e.response.data.messages[0].message){
                //Return FM Error Response
                return e.response.data
            }
            else{
                //Format Unknown Error Like a FM Error
                return  `{ messages:[message: ${e.message}, code: -1],response: {}}`
            }
        })
    },
    loadExpirationDate: function(scriptParameters){
        var args = `{
            "params" : ${JSON.stringify(scriptParameters)}
        }`
        return axios.post(`loadExpirationDate.php`, args)
        .then((response) => {
            // success callback
            return response.data
        })
        .catch( (e) => {
            if(e.response.data.messages[0].message){
                //Return FM Error Response
                return e.response.data
            }
            else{
                //Format Unknown Error Like a FM Error
                return  `{ messages:[message: ${e.message}, code: -1],response: {}}`
            }
        })
    },
    loadSharedDocument: function(scriptParameters){
        var args = `{
            "params" : ${JSON.stringify(scriptParameters)}
        }`
        return axios.post(`loadSharedDocument.php`, args)
        .then((response) => {
            // success callback
            return response.data
        })
        .catch( (e) => {
            if(e.response.data.messages[0].message){
                //Return FM Error Response
                return e.response.data
            }
            else{
                //Format Unknown Error Like a FM Error
                return  `{ messages:[message: ${e.message}, code: -1],response: {}}`
            }
        })
    },
    loadMobileDocument: function(scriptParameters){
        var args = `{
            "params" : ${JSON.stringify(scriptParameters)}
        }`
        return axios.post(`loadMobileDocument.php`, args)
        .then((response) => {
            // success callback
            return response.data
        })
        .catch( (e) => {
            if(e.response.data.messages[0].message){
                //Return FM Error Response
                return e.response.data
            }
            else{
                //Format Unknown Error Like a FM Error
                return  `{ messages:[message: ${e.message}, code: -1],response: {}}`
            }
        })
    },
    loadFilterObjects: function(){
        return axios.post(`loadValueLists.php`)
        .then((response) => {
            // success callback
            return response.data
        })
        .catch( (e) => {
            if(e.response.data.messages[0].message){
                //Return FM Error Response
                return e.response.data
            }
            else{
                //Format Unknown Error Like a FM Error
                return  `{ messages:[message: ${e.message}, code: -1],response: {}}`
            }
        })
    }
}